import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { rolesKeys } from '../api/roles.keys'
import { rolesApi, GetRolesParams } from '../api/roles.api'
import { Role } from '../types'

const normalizeRole = (item: any): Role => {
    const isSys = item.is_system_role ?? false
    const modifiedAt = item.modified_at ?? item.updated_at ?? item.updatedDate ?? ''
    return {
        id: String(item.role_id ?? item.id ?? ''),
        label: item.label,
        name: item.role_name ?? item.name ?? '',
        type: isSys ? 'Default' : 'Custom',
        createdDate: item.created_at ?? item.createdDate ?? '',
        associatedUsers: Number(item.user_count ?? item.associatedUsers ?? 0),
        deletedDate: modifiedAt || item.deleted_at || item.deletedDate || '',
        updatedDate: modifiedAt || '',
    }
}

export function useRoles(params?: GetRolesParams) {
    const keyString = params ? JSON.stringify(params) : undefined

    return useQuery<Role[], Error>({
        queryKey: rolesKeys.allRoles(keyString),
        queryFn: async () => {
            const result = await rolesApi.getAllRoles(params)
            let rawItems: any[] = []

            if (Array.isArray(result)) {
                rawItems = result
            } else if (result && Array.isArray(result.data)) {
                rawItems = result.data
            }

            return rawItems.map(normalizeRole)
        },
        staleTime: 5 * 60 * 1000,
    })
}

export function useToggleRoleActive() {
    const queryClient = useQueryClient()

    return useMutation<void, Error, string | number>({
        mutationFn: (roleId: string | number) => rolesApi.toggleActiveRole(roleId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: rolesKeys.allRoles() })
            queryClient.invalidateQueries({ queryKey: rolesKeys.allRoles(JSON.stringify({ is_active: true })) })
            queryClient.invalidateQueries({ queryKey: rolesKeys.allRoles(JSON.stringify({ is_active: false })) })
        },
    })
}

